import * as React from 'react';
import { useIntl } from 'react-intl';
import TooltipComponent from '../../TooltipComponent';
import useAnalytics from '../../../hooks/useAnalytics';

interface IAddressProps {
  start: string;
  end: string;
  startLink: string | null;
  endLink: string | null;
  datacyIndex: number;
}

const WORD_RULE_LENGTH = 50;

function Address(props: IAddressProps) {
  const { formatMessage: f } = useIntl();
  const { trackEvent } = useAnalytics();
  const redirectToMap = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.stopPropagation();
    trackEvent(['ride book', 'click', 'Ride book open address in new tab']);
  };

  const renderRecords = () => {
    return (
      <div style={{ color: '#fff' }}>
        <div>{props.start ? props.start : '-'}</div>
        <div>{props.end ? props.end : '-'}</div>
      </div>
    );
  };
  return (
    <div className="align-middle" style={{ whiteSpace: 'nowrap', minWidth: '350px', flex: 1 }}>
      {(props.start && props.start.length > WORD_RULE_LENGTH) ||
      (props.end && props.end.length > WORD_RULE_LENGTH) ? (
        <TooltipComponent id={props.start} overlay={renderRecords()} width="auto">
          {props.startLink ? (
            <a
              data-cy={`row-${props.datacyIndex + 1}-Address_Start`}
              href={props.startLink}
              target="_blank"
              className="d-block w-100"
              style={{ textOverflow: 'ellipsis', overflow: 'hidden' }}
              onClick={redirectToMap}
              rel="noreferrer"
            >
              {props.start && props.start.length > WORD_RULE_LENGTH
                ? `${props.start.substring(0, WORD_RULE_LENGTH)} ...`
                : props.start
                ? props.start
                : '-'}
            </a>
          ) : (
            <>
              {props.start && props.start.length > WORD_RULE_LENGTH
                ? `${props.start.substring(0, WORD_RULE_LENGTH)} ...`
                : props.start
                ? props.start
                : '-'}
            </>
          )}
          {props.endLink && (
            <a
              data-cy={`row-${props.datacyIndex + 1}-Address_End`}
              href={props.endLink}
              target="_blank"
              className="d-block w-100 mt-1"
              style={{ textOverflow: 'ellipsis', overflow: 'hidden' }}
              onClick={redirectToMap}
              rel="noreferrer"
            >
              {props.end && props.end.length > WORD_RULE_LENGTH
                ? `${props.end.substring(0, WORD_RULE_LENGTH)} ...`
                : props.end
                ? props.end
                : '-'}
            </a>
          )}
        </TooltipComponent>
      ) : (
        <div>
          <div data-cy={`row-${props.datacyIndex + 1}-Address_Start`}>
            {props.startLink ? (
              <a target="_blank" href={props.startLink} onClick={redirectToMap} rel="noreferrer">
                {props.start ? props.start : '-'}
              </a>
            ) : (
              <>{f({ id: 'tables.tripsOverview.column.datetime.anonymized' })}</>
            )}
          </div>
          <div data-cy={`row-${props.datacyIndex + 1}-Address_End`} className="mt-1">
            {props.endLink && (
              <a target="_blank" href={props.endLink} onClick={redirectToMap} rel="noreferrer">
                {props.end ? props.end : '-'}
              </a>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default Address;
